<dialog #dialog id="gli-confirmation-dialog" class="gli-modal" closedby="none"
  aria-modal="true" aria-labelledby="gli-confirmation-title" aria-describedby="gli-confirmation-message"
  (cancel)="$event.preventDefault()" (close)="decided.emit(false)">
  <div class="kt-modal-content w-full max-w-lg my-5 lg:my-15">
    <div class="kt-modal-header">
      <h2 id="gli-confirmation-title" class="kt-modal-title">{{ options().title }}</h2>
    </div>
    <div class="kt-modal-body">
      <p id="gli-confirmation-message" class="whitespace-pre-line break-words text-sm text-foreground">{{ options().message }}</p>
    </div>
    <div class="kt-modal-footer justify-end gap-3">
      <button type="button" class="kt-btn kt-btn-outline" data-confirmation-action="cancel"
        autofocus (click)="decided.emit(false)">{{ options().cancelText ?? 'Cancel' }}</button>
      <button type="button" class="kt-btn" [class.kt-btn-primary]="!options().destructive"
        [class.kt-btn-destructive]="options().destructive" data-confirmation-action="confirm"
        (click)="decided.emit(true)">{{ options().confirmText ?? 'Continue' }}</button>
    </div>
  </div>
</dialog>
